<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
    <div class="header">
      <div class="toolbar">
        <button (click)="zoomIn()" [disabled]="scale >= 1.6">
          <i class="fa fa-plus margin-vertical-middle"></i>
        </button>
        <button (click)="zoomOut()" [disabled]="scale <= 1">
          <i class="fa fa-minus margin-vertical-middle"></i>
        </button>
        <button (click)="previousDocument()" [disabled]="!hasPrevious"><i class="fa fa-arrow-left"></i></button>
        <button (click)="nextDocument()" [disabled]="!hasNext"><i class="fa fa-arrow-right"></i></button>
        <button (click)="downloadDocument()"><i class="fa fa-download"></i></button>
      </div>
      <span class="close" (click)="closeModal()">&times;</span>
    </div>
    <div *ngIf="isPdf" style="height: 95%; width: 95%">
      <pdf-viewer
        [src]="documentUrlWithoutFileName"
        [zoom]="scale"
        [original-size]="false"
        [c-maps-url]="'/assets/pdfjs/cmaps/'"
        style="width: 100%; height: 100%; overflow: auto"
        (after-load-complete)="afterPDFLoadComplete($event)"
      ></pdf-viewer>
    </div>
    <div *ngIf="isImage" class="image-container">
      <img [src]="documentUrlWithoutFileName" [style.transform]="'scale(' + scale + ')'" />
    </div>

    <div *ngIf="isDoc" class="office-viewer">
      <div
        #docxContainer
        style="width: 100%; height: 100%; overflow: auto"
        [style.transform]="'scale(' + scale + ')'"
      ></div>
    </div>
  </div>
</div>
